import React from 'react';

import { uniqueSpecContractList } from '@/common/constants/contract';
import { type ContractDataType } from '@/common/types/contract';

import { ContractSoon } from './ContractSoon';

interface ContractSoonBlockProps {
  isUninitialized: boolean;
  contractList?: ContractDataType[];
  userLevel: number;
}

const ContractSoonBlock: React.FC<ContractSoonBlockProps> = ({
  contractList,
  userLevel,
  isUninitialized,
}) => {
  return uniqueSpecContractList.map((kind) => (
    <ContractSoon
      key={`soon-contract-${kind}`}
      kind={kind}
      userLevel={userLevel}
      isUninitialized={isUninitialized}
      withDefaultContracts={!!contractList}
    />
  ));
};

export default ContractSoonBlock;
